module.exports = __webpack_public_path__ + "img/nevi_teaser_mobile_connect_with_nevi.5f01b733.png";